import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/lib/api";
import logo from "@/assets/logo_ethos.png";

export const Navbar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 nav-blur" data-testid="navbar">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img src={logo} alt="Ethos Foundation" className="h-9 lg:h-10 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`nav-link font-body-eth text-[13px] font-medium tracking-wide ${
                pathname === n.to ? "active" : ""
              }`}
            >
              {n.label}
            </Link>
          ))}
          <Link
            to="/donate"
            data-testid="nav-donate"
            className="btn-gold font-body-eth text-[13px] font-semibold px-5 py-2.5 tracking-wide"
          >
            Donate Now
          </Link>
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ink border-t border-white/10 px-6 py-5 flex flex-col gap-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={`nav-link font-body-eth text-sm ${pathname === n.to ? "active" : ""}`}
            >
              {n.label}
            </Link>
          ))}
          <Link to="/donate" className="btn-gold text-center font-semibold px-5 py-2.5 text-sm">
            Donate Now
          </Link>
        </div>
      )}
    </header>
  );
};
